import TemplateView from "../../TemplateView";
import CommentsNumberContainer from '../../taskManagement/components/CommentsNumberContainer'

export default class IconNameContainer extends TemplateView {

    constructor($containerEl, {title, icon, onClick, commentsNumber}) {
        super($containerEl);

        this.props = {
            icon,
            onClick,
            commentsNumber,
        };

        this.title = title;
        this.$containerEl = $containerEl
    }

    templateHtml() {
        return "<div class='iconNameContainer'>" +
               "  <div class='iconContainer'></div>" +
               "  <div class='lockTableEllipsis'><%-title%></div>" +
               "  <div class='commentsNumberPlaceholder'></div>" +
               "</div>";
    }

    afterRender() {
        this.props.icon.init(this.find(".iconContainer"));

        let commentsNumber = new CommentsNumberContainer().init(this.find('.commentsNumberPlaceholder'))
        commentsNumber.setState({
            commentsNumber: this.props.commentsNumber,
        })

        this.$el.click(this.props.onClick)
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/components/IconNameContainer.js